import { useState, useEffect } from 'react';

export const useForm = (initialForm, validateForm, handleClick) => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});
  const [submit, setSubmit] = useState(false);
  const [pressSubmit, setPressSubmit] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && submit) {
      handleClick();
    }
    // eslint-disable-next-line
  }, [errors]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: value
    });
  };

  const handleKeyUp = (e) => {
    const { name } = e.target;

    const { allErrors, allValidFields } = validateForm(form);

    if (pressSubmit) {
      setErrors(allErrors);
      setValidFields(allValidFields);
    } else {
      const err = allErrors[name];
      if (err) {
        setErrors({ ...errors, [name]: err });
      } else {
        const { [name]: remove, ...rest } = errors;
        setErrors(rest);
      }

      const valid = allValidFields[name];
      if (valid) {
        setValidFields({ ...validFields, [name]: valid });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setPressSubmit(true);

    const { allErrors, allValidFields } = validateForm(form);
    setErrors(allErrors);
    setValidFields(allValidFields);

    if (Object.keys(allErrors).length !== 0) return;
    setSubmit(true);
  };

  return {
    form,
    errors,
    validFields,
    setErrors,
    handleChange,
    handleKeyUp,
    handleSubmit
  };
};
